module.exports = __webpack_public_path__ + "img/union-por-el-peru.f4867812.png";